import React from "react"

function PageWrapper({ children, prose }) {
  const classes = `mx-4 md:m-auto py-10 md:py-20 ${prose ? "max-w-prose" : ""}`

  return <div className={classes}>{children}</div>
}

export default PageWrapper
